import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-markdown-editor',
  template: `<div></div>`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MockMarkdownEditorComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class MockMarkdownEditorComponent implements ControlValueAccessor {
  disabled = false;
  onChange = (_: string) => {};
  onTouched = () => {};

  writeValue(): void {}

  registerOnChange(fn: (_: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
